import { css } from "../../../../styled-system/css";
import { Select } from "../../fields/base/Select";

const SearchFilter = ({ selectedSearchId, shelfData, selectedShelf, filterSearchId }) => {
  const shelf = shelfData.find((s) => s.id === selectedShelf);
  const defaultOptions = [
    {
      label: "All Keywords",
      value: "all",
    },
  ];
  const options = defaultOptions.concat(
    shelf?.searches?.map((s) => ({
      label: s.display || s.value,
      value: s.id,
    })) ?? [],
  );
  return (
    <Select
      items={options}
      selectedKey={selectedSearchId === null ? "all" : selectedSearchId}
      onSelectionChange={(v) => filterSearchId(v === "all" ? null : v)}
      className={css({ maxWidth: "200px" })}
      aria-label={"Select keyword"}
    />
  );
};

export default SearchFilter;
